import * as React from 'react';
import { connect } from 'react-redux';
import { IFrontState } from '../../frontReducers';
import { IFile as IFileSystemFile } from '../../../NativeDevice/fileSystem';
import MainInfo from '../Info/MainInfo';
import InfoProperty from '../Info/InfoProperty';
import GaplessApplet from './GaplessApplet';
import { CreateAppletIframe, RemoveAppletIframe, StartAppletIframe } from '../../AppletTiming/appletTimingActions';
import DeviceInfo from '../Info/DeviceInfo';
import SuccessIcon from '../Application/Icons/SuccessIcon';
import 'typeface-muli';
import TimeInfo from '../Info/TimeInfo';
import iconStyles from '../Application/Icons/SuccessIcon.module.sass';
import { formatTimerOffMessage } from '../../../Screen/mutedMessage';

export interface IStateProps {
	appletUid: string;
	appletBinaryFile: IFileSystemFile;
	appletMissing: boolean;
	appletUniqueHash: string;
	appletChecksum: string;
	nextAppletUid?: string;
	nextAppletBinaryFile?: IFileSystemFile;
	nextAppletChecksum?: string;
	deviceName: string;
	model: string | null;
	organizationTitle: string;
	appletIsMuted: boolean;
	timerNextPowerOn: Date | null;
	applicationType: string | null;
	ethernetMacAddress: string | null;
	wifiMacAddress: string | null;
	serialNumber: string | null;
	frontDisplayVersion: string;
	applicationVersion: string;
	timezone: string;
	timestamp: number;
	ipAddress: string;
	interfaceName: string;
	osVersion: string;
	firmwareVersion: string;
}
export interface IDispatchProps {
	onAppletIframeCreated(appletUid: string, appletIframeId: string): void;
	onAppletIframeStarted(appletUid: string, appletIframeId: string): void;
	onAppletIframeRemoved(appletIframeId: string): void;
}

export class ActiveApplet extends React.PureComponent<IStateProps & IDispatchProps> {
	public render() {
		if (this.props.appletIsMuted) {
			return (
				<div>
					<img
						src='data:image/svg+xml;base64,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'
						alt='eye closed icon'
						className={iconStyles.rightTopIcon}
					/>
					<MainInfo title='Device name:' value={this.props.deviceName || '-- No Name --'}>
						{this.getMutedMessage()}
					</MainInfo>
				</div>
			);
		} else if (this.props.appletMissing) {
			return (
				<div>
					<MainInfo title='Device name:' value={this.props.deviceName || '-- No Name --'} />
					<TimeInfo timestamp={this.props.timestamp} timezone={this.props.timezone} />
					<DeviceInfo>
						{/* Device specific */}
						<InfoProperty title='Device:'>{this.getDeviceModel()}</InfoProperty>
						<InfoProperty title='System:'>{this.getSystemLabel()}</InfoProperty>
						{this.props.osVersion ? <InfoProperty title='System Version:'>{this.props.osVersion}</InfoProperty> : null}
						{this.props.firmwareVersion ? <InfoProperty title='Firmware Version:'>{this.props.firmwareVersion}</InfoProperty> : null}
						{this.props.serialNumber ? <InfoProperty title='Serial Number:'>{this.props.serialNumber}</InfoProperty> : null}

						{/* Application specific */}
						<InfoProperty title='Front Display Version:'>{this.props.frontDisplayVersion}</InfoProperty>
						<InfoProperty title='Application Version:'>{this.props.applicationVersion}</InfoProperty>
						{this.props.organizationTitle ? <InfoProperty title='Organization:'>{this.props.organizationTitle}</InfoProperty> : null}

						{/* Network specific */}
						{this.props.interfaceName ? <InfoProperty title='Interface:'>{this.props.interfaceName}</InfoProperty> : null}
						{this.props.ipAddress ? <InfoProperty title='Local IP Address:'>{this.props.ipAddress}</InfoProperty> : null}
						{this.props.wifiMacAddress ? <InfoProperty title='Wifi Mac Address:'>{this.props.wifiMacAddress}</InfoProperty> : null}
						{this.props.ethernetMacAddress ? (
							<InfoProperty title='Ethernet Mac Address:'>{this.props.ethernetMacAddress}</InfoProperty>
						) : null}

						{/* Other specifics */}
						<InfoProperty title='Status:'>No content applet configured</InfoProperty>
					</DeviceInfo>
					<SuccessIcon />
				</div>
			);
		} else if (this.props.appletChecksum) {
			return (
				<GaplessApplet
					appletUid={this.props.appletUid}
					checksum={this.props.appletChecksum}
					uniqueHash={this.props.appletUniqueHash}
					binaryFile={this.props.appletBinaryFile}
					nextAppletUid={this.props.nextAppletUid}
					nextChecksum={this.props.nextAppletChecksum}
					nextBinaryFile={this.props.nextAppletBinaryFile}
					onCreated={(iframeElement: HTMLIFrameElement, appletUid: string) => this.props.onAppletIframeCreated(appletUid, iframeElement.id)}
					onStart={(iframeElement: HTMLIFrameElement, appletUid: string) => this.props.onAppletIframeStarted(appletUid, iframeElement.id)}
					onRemoved={(iframeId: string) => this.props.onAppletIframeRemoved(iframeId)}
				/>
			);
		} else {
			return null;
		}
	}

	private getMutedMessage() {
		return formatTimerOffMessage(this.props.timerNextPowerOn, { playbackRunning: false });
	}

	private getSystemLabel() {
		return this.props.applicationType ? this.props.applicationType.toUpperCase() : 'UNKNOWN';
	}

	private getDeviceModel() {
		return this.props.model ? this.props.model : 'Unknown';
	}
}

export default connect(
	(state: IFrontState) =>
		({
			appletUid: state.applet.activeAppletUid,
			appletBinaryFile: state.applet.activeAppletBinaryFile,
			appletMissing: state.applet.activeAppletMissing,
			appletUniqueHash: state.applet.activeAppletUniqueHash,
			appletChecksum: state.applet.activeTimingChecksum,
			nextAppletUid: state.applet.nextApplet ? state.applet.nextApplet.uid : undefined,
			nextAppletBinaryFile: state.applet.nextApplet ? state.applet.nextApplet.appletBinaryFile : undefined,
			nextAppletChecksum: state.applet.nextApplet ? state.applet.nextApplet.timingChecksum : undefined,
			deviceName: state.device.deviceName,
			model: state.device.model,
			organizationTitle: state.organization.organizationTitle,
			appletIsMuted: state.applet.appletIsMuted,
			timerNextPowerOn: state.applet.timerNextPowerOn,
			applicationType: state.device.applicationType,
			ethernetMacAddress: state.device.ethernetMacAddress,
			wifiMacAddress: state.device.wifiMacAddress,
			serialNumber: state.device.serialNumber,
			frontDisplayVersion: state.device.frontDisplayVersion,
			timezone: state.device.timezone,
			timestamp: state.device.timestamp,
			applicationVersion: state.device.applicationVersion,
			ipAddress: state.device.ipAddress,
			interfaceName: state.device.activeInterface,
			osVersion: state.device.osVersion,
			firmwareVersion: state.device.firmwareVersion,
		}) as IStateProps,
	(dispatch: (action: CreateAppletIframe | StartAppletIframe | RemoveAppletIframe) => void) =>
		({
			onAppletIframeCreated: (appletUid: string, appletIframeId: string) =>
				dispatch({
					type: CreateAppletIframe,
					uid: appletUid,
					id: appletIframeId,
				} as CreateAppletIframe),
			onAppletIframeStarted: (appletUid: string, appletIframeId: string) =>
				dispatch({
					type: StartAppletIframe,
					uid: appletUid,
					id: appletIframeId,
				} as StartAppletIframe),
			onAppletIframeRemoved: (appletIframeId: string) =>
				dispatch({
					type: RemoveAppletIframe,
					id: appletIframeId,
				} as RemoveAppletIframe),
		}) as IDispatchProps,
)(ActiveApplet);
